export const env: { [s: string]: string; } = {'npm_package_version':'1.25.43','npm_package_pre_release_number':'12505'};
